import { getFlatsByGridData } from '../utils/getFlatsByGridData';

const useHousesCountByAcceptanceStage = (
  acceptanceStatuses = [],
  gridData = []
) => {
  if (!acceptanceStatuses?.length || !gridData?.length) {
    return [];
  }

  const DEFAULT_STATUS_ID = 0;
  const DEFAULT_STATUS = {
    id: DEFAULT_STATUS_ID,
    value: 'Приемка не проводилась',
  };

  const flats = getFlatsByGridData(gridData);

  const mapStatuses = new Map(
    [...acceptanceStatuses, DEFAULT_STATUS].map((status) => [
      status.id,
      { ...status, count: 0 },
    ])
  );

  flats.forEach((flat) => {
    const statusId =
      flat?.addressLifeCycle?.acceptanceStatusAddressLifeCycle?.id ||
      DEFAULT_STATUS_ID;

    const current = mapStatuses.get(statusId);

    mapStatuses.set(statusId, { ...current, count: current.count + 1 });
  });

  return Array.from(mapStatuses.values());
};

export default useHousesCountByAcceptanceStage;
